// Previously uncatalogued fallback strings used by customer-facing screens.
window.PlummeI18n.register('en', {
  "common.rowUnavailable": "The data could not be loaded. Try again.",
  "common.rowContextChanged": "The selected business or document changed. Open it again.",
  "common.bankStatementIncomplete": "The bank statement is not fully loaded. Try again.",
  "common.journalProofUnavailable": "The accounting data could not be verified.",

  'pay.employeesAwaitingPayment': '{{count}} employees awaiting payment',
  'pay.readyForPayment': 'Ready for payment',
  'pay.readyForPaymentHelp': 'Approved and posted payroll runs with salary payments that have not yet been recorded.',
  'pay.noRunsAwaitingPayment': 'No payroll runs are awaiting payment',
  'pay.noRunsAwaitingPaymentHint': 'Approved payroll runs appear here until their payments are recorded.',
  'pay.draftPayrollRuns': 'Drafts',
  'pay.noDraftPayrollRuns': 'No payroll drafts.',
  'buy.ownerOutlay': 'Owner outlay',
  'home.followup.assetPostingTitle': 'Depreciation',
  'home.followup.assetPostingAction': 'View issue',
  'home.followup.assetPostingIssue': 'Automatic depreciation needs attention. Check the asset plan or contact support. Plumme retries after the issue is corrected.',
  'ui.cancel': 'Cancel', 'ui.close': 'Close', 'ui.back': 'Back', 'ui.continue': 'Continue', 'ui.open': 'Open',
  'app.close': 'Close', 'common.loadMore': 'Load more', 'common.loading': 'Loading...', 'shell.collapse': 'Collapse menu',
  'chat.cardFromFirm': 'Your accountant wrote', 'chat.cardFromYou': 'You wrote', 'chat.cardNone': 'No messages yet',
  'chat.firm': 'Your accountant', 'chat.helpTitle': 'Your accountant',
  'chat.help': 'Write directly to your accountant. Only you as an owner or administrator can see this conversation.',
  'chat.cardOpenUnread': 'Read the message', 'chat.cardOpen': 'Send a message',
  'chat.modalTitle': 'You have an unread message', 'chat.modalOpen': 'Open chat',
  'chat.modalBody': 'has sent you a message you have not read.',
  'chat.client': 'The client', 'chat.subFirm': 'Conversation with the client', 'chat.subClient': 'Conversation with your accountant',
  'chat.emptyFirm': 'No messages yet. Write to the client here — they will see it in Plumme.',
  'chat.emptyClient': 'No messages yet. Ask your accountant about anything you need help with.',
  'chat.placeholder': 'Write a message …', 'chat.send': 'Send',
  'rf.client.takeoverSaved': 'The takeover date has been saved.', 'rf.client.takeover': 'Takeover date',
  'rf.client.takeoverHelp': 'Periods and deadlines before this date are not treated as the firm’s work. The client’s own obligations are unchanged.',
  'rf.client.takeoverSave': 'Save date',
  'clo.cash.invalidAmount': 'Enter the counted cash balance.',
  'clo.cash.documentationRequired': 'Describe the count documentation before approving.',
  'clo.cash.saved': 'The cash count has been saved.', 'clo.cash.saveError': 'Could not save the cash count.',
  'clo.cash.title': 'Coins and notes', 'clo.cash.readySubtitle': 'Cash has been counted and agrees with account 1900.',
  'clo.cash.naSubtitle': 'No cash balance is recorded in account 1900.',
  'clo.cash.todoSubtitle': 'Count the cash at 31 December and compare it with account 1900.',
  'clo.cash.noStatus': 'Cash status has not been calculated yet.', 'clo.cash.booked': 'Posted to 1900',
  'clo.cash.counted': 'Counted at 31 December', 'clo.cash.difference': 'Difference',
  'clo.cash.countedField': 'Counted cash balance', 'clo.cash.account': 'Cash account',
  'clo.cash.documentation': 'Cash count documentation',
  'clo.cash.documentationPlaceholder': 'For example: Cash counted on 31 December by the general manager. The count sheet is saved with the vouchers.',
  'clo.cash.noDifferenceHelp': 'When the count agrees with account 1900, it is saved as documentation without an additional posting.',
  'clo.cash.surplusHelp': 'The difference increases account 1900 and is posted against other income.',
  'clo.cash.shortageHelp': 'The difference reduces account 1900 and is posted against other expenses.',
  'clo.cash.approve': 'Approve count',
  'clo.chart.suggestionsReady': 'The suggestions are ready for approval.', 'clo.chart.noSuggestions': 'No reliable suggestions found.',
  'clo.chart.pickBeforeApprove': 'Select a standard account before approving.', 'clo.chart.saved': '{{count}} account mappings saved',
  'clo.chart.saveError': 'Could not save the account mappings.', 'clo.chart.title': 'Chart of accounts',
  'clo.chart.missingSubtitle': '{{count}} custom accounts are missing a standard account mapping.',
  'clo.chart.readySubtitle': 'The chart of accounts is ready for year-end closing.',
  'clo.chart.allMapped': 'All custom accounts are mapped to standard accounts.',
  'clo.chart.instructions': 'Select the standard account that each custom account corresponds to.',
  'clo.chart.aiSuggest': 'Find suggestions with AI', 'clo.chart.accountFallback': 'Account {{code}}',
  'clo.chart.missingMapping': 'Missing standard mapping', 'clo.chart.equivalent': 'Corresponding standard account',
  'clo.chart.reset': 'Reset suggestions', 'clo.chart.approve': 'Approve {{count}} suggestions',
  'clo.share.title': 'Share capital', 'clo.share.readySubtitle': 'The share capital is posted to account 2000.',
  'clo.share.missingSubtitle': 'Check or post the share capital before completing year-end closing.',
  'clo.share.noStatus': 'Share capital status has not been calculated yet.', 'clo.share.booked': 'Posted to 2000',
  'clo.share.minimum': 'Minimum for a Norwegian AS',
  'clo.share.lossNote': 'Losses or lost equity should normally not be posted out of account 2000. They are assessed under equity, profit allocation and going concern. This item only checks that registered share capital is posted as a credit to account 2000.',
  'clo.share.freePosting': 'Post share capital',
});

// Shared labels must be available before any route-specific catalog loads.
window.PlummeI18n.register('en', {
  "sharedText.app.employeePortalVerifyTitle": "Confirm your email address",
  "sharedText.auth.remember": "Remember me",
  "sharedText.auth.noAccount": "No account yet?",
  "sharedText.auth.forgotCopy": "Enter the email you sign in with, and we will send you a link to set a new password.",
  "sharedText.acc.sentLinkTo": "We have sent a link to",
  "sharedText.rep.export.year": "Year",
  "sharedText.bank.previewVoucher": "Preview the voucher",
  "sharedText.km.returnTrip": "Return trip",
  "sharedText.pay.paidOut": "Paid out",
  "sharedText.inv.col.net": "Net",
  "sharedText.transaction.by": "by",
  "sharedText.buy.pickCategory": "Account/category",
  "sharedText.vat.vat": "VAT",
  "sharedText.sup.seeVoucher": "View voucher",
  "sharedText.bwf.correctEntry": "Correct posting",
  "sharedText.ap.approve": "Approve",
  "sharedText.sale.pay.partialStatusRemaining": "remaining",
  "sharedText.helpTopics.ocrCorrection.title": "Correct extracted values",
  "sharedText.pay.note": "Note",
  "sharedText.bank.openingBalance": "Opening balance",
  "sharedText.asset.closing": "Closing balance",
  "sharedText.sale.att.dropHere": "Drop the attachment here",
  "sharedText.voucher.pickAccount": "Choose account",
  "sharedText.adv.scn.plan.interest": "Interest",
  "sharedText.sale.pay.fee": "Fee",
  "sharedText.ui.cancel": "Cancel",
  "sharedText.bwf.selectLine": "Select bank line",
  "sharedText.bg.bankLines": "Bank lines",
  "sharedText.home.ana.ring": "Breakdown",
  "sharedText.pj.row.new": "New row",
  "sharedText.bank.bankLine": "Bank line",
  "sharedText.helpTopics.openItem.title": "Open item",
  "sharedText.clo.amount": "Amount",
  "sharedText.adv.status.more": "More options",
  "sharedText.inboxStatus.dropReceipts": "Drop the receipts here",
  "sharedText.bank.uploading": "Uploading …",
  "sharedText.set.showAll": "Show all",
  "sharedText.bank.voucherReceivedOn": "Voucher received on",
  "sharedText.set.acc.lines": "lines",
  "sharedText.nav.budget": "Budget",
  "sharedText.bud.actual": "Actual",
  "sharedText.ui.close": "Close",
  "sharedText.pay.signOut": "Sign out",
  "sharedText.rf.group.firm": "Accountant",
  "sharedText.rf.create.title": "Create accounting firm",
  "sharedText.ui.open": "Open",
  "sharedText.buy.next": "Next",
  "sharedText.adv.docs.hide": "Hide",
  "sharedText.fe.decline": "Decline",
  "sharedText.common.yes": "Yes",
  "sharedText.ap.review.checked": "Checked",
  "sharedText.clo.pick": "Choose",
  "sharedText.nav.taxReturn": "Tax return",
  "sharedText.clo.financialYear": "The financial year",
  "sharedText.helpTopics.residualValue.title": "Residual value",
  "sharedText.clo.inventoryReview.undecided": "Choose assessment",
  "sharedText.helpTopics.readyForUse.title": "Ready for use",
  "sharedText.asset.work.residualValue": "Expected residual value",
  "sharedText.inv.credit.line": "Line",
  "sharedText.buy.paid": "Paid",
  "sharedText.km.from": "From",
  "sharedText.km.to": "To",
  "sharedText.set.accountNo": "Account no.",
  "sharedText.sale.credit.previewReason": "Reason:",
  "sharedText.clo.description": "Description",
  "sharedText.prd.price": "Price",
  "sharedText.clo.sum": "Total",
  "sharedText.inv.kpi.sub.exVat": "Excl. VAT",
  "sharedText.set.page": "Page",
  "sharedText.sale.cust.org": "Company no.",
  "sharedText.trv.vehicle": "Vehicle",
  "sharedText.ap.monthControl.finding.deviation": "Possible deviation",
  "sharedText.vat.cancel": "Cancel",
  "sharedText.bank.review": "Review",
  "sharedText.inbox.supplierInvoice": "Supplier invoice",
  "sharedText.bank.roundingHelp": "Only use this for a genuine small rounding difference. The amount is posted without VAT against",
  "sharedText.trv.reason": "Reason",
  "sharedText.set.acc.vatRegisteredPick": "Choose an answer",
  "sharedText.set.acc.vatRegisteredUnknown": "Not sure",
  "sharedText.set.acc.vatRegisteredFrom": "VAT registered from",
  "sharedText.vat.due": "Deadline",
  "sharedText.pay.advance": "Advance",
  "sharedText.pay.aga": "Employer's contribution",
  "sharedText.inv.col.number": "No.",
  "sharedText.onb.createPersonal": "Create your personal finances",
  "sharedText.onb.createPersonalHelp": "This creates a separate personal finance user, which you find from My page and the user switcher.",
  "sharedText.onb.noBankData": "Bank connection is not active yet. You can upload bank statements manually whenever you like.",
  "sharedText.po.youHaveStated": "You have stated that",
  "sharedText.po.wealthStrongestOn": "Your wealth scores strongest on",
  "sharedText.po.withYourAssumptions": "With the assumptions you have entered, your wealth changes by roughly",
  "sharedText.po.splitIsEven": "The split is even. You share",
  "sharedText.po.householdHasRegistered": "The household has registered",
  "sharedText.po.budgetTotal": "Budget total:",
  "sharedText.set.bank.typeTax": "Tax withholding",
  "sharedText.clo.no": "No",
  "sharedText.po.showingScenario": "Showing scenario:",
  "sharedText.po.desiredNetWealth": "Desired net wealth",
  "sharedText.po.lastsUntilYouAre": "lasts until you are",
  "sharedText.sd.transition.years": "years",
  "sharedText.po.lasts": "lasts",
  "sharedText.po.prioritise": "Prioritise",
  "sharedText.adv.scn.loan.monthsUnit": "mo",
  "sharedText.po.doYouWantToDelete": "Do you want to delete",
  "sharedText.po.householdSpends": "The household spends",
  "sharedText.po.iRecommend": "I recommend",
  "sharedText.po.debtFree": "Debt free",
  "sharedText.po.interestPostedAs": "Interest and instalments on this loan are posted as",
  "sharedText.helpTopics.buffer.title": "Liquid buffer",
  "sharedText.clo.save": "Save",
  "sharedText.adv.profile.buffer": "Desired buffer",
  "sharedText.home.legend.income": "Income",
  "sharedText.set.bank.typeSavings": "Savings",
  "sharedText.pay.category": "Category",
  "sharedText.set.account": "Account",
  "sharedText.po.allAccounts": "All accounts",
  "sharedText.adv.status.snooze7": "Remind me in a week",
  "sharedText.po.yourHealthScoreIs": "Your health score is",
  "sharedText.po.outOf100": "out of 100",
  "sharedText.po.taxAssistant": "Tax return assistant",
  "sharedText.cust.prev": "Previous",
  "sharedText.bank.finishReview": "Finish the review",
  "sharedText.po.checkBasis": "Basis for the check",
  "sharedText.clo.name": "Name",
  "sharedText.set.text": "Text",
  "sharedText.sale.textLine.boldShort": "B",
  "sharedText.sale.textLine.italicShort": "I",
  "sharedText.sale.lines.useDivider": "Use divider line",
  "sharedText.sale.textLine.dividerHint": "Show a line under the text in the document.",
  "sharedText.nav.products": "Products",
  "sharedText.sale.textLine.titleNewText": "New text line",
  "sharedText.prd.deleted": "Deleted",
  "sharedText.pay.edit": "Edit",
  "sharedText.clo.delete": "Delete",
  "sharedText.set.loans.startDate": "Start date",
  "sharedText.helpTopics.unitCost.title": "Unit cost",
  "sharedText.pay.optional": "Optional",
  "sharedText.registry.group": "Product group",
  "sharedText.clo.add": "Add",
  "sharedText.ha.products.account": "Income account",
  "sharedText.clo.accountNumber": "Account number",
  "sharedText.clo.accountName": "Account name",
  "sharedText.buy.supplierNew": "New supplier",
  "sharedText.auth.createAccount": "Create account",
  "sharedText.set.acc.equivalent": "Corresponds to account",
  "sharedText.bwf.entry": "Entry",
  "sharedText.sale.att.upload": "Upload attachment",
  "sharedText.vat.settlement": "Settlement",
  "sharedText.ap.agent.invoice.selectRow": "Select invoice",
  "sharedText.ap.workspace.treatmentAsset": "Register as fixed asset",
  "sharedText.bank.receiptLinked": "Linked to a bank line",
  "sharedText.sd.documents.count": "documents",
  "sharedText.set.debit": "Debit",
  "sharedText.set.bank.accounts": "Bank accounts",
  "sharedText.sd.deleteBusinessHelp": "Delete business removes the selected business after 30 days via the backend. This is a serious action.",
  "sharedText.vat.rate": "Rate",
  "sharedText.inv.bulk.noEmail": "no email",
  "sharedText.trv.privateRefundOf": "Private refund of",
  "sharedText.asset.group": "Group",
  "sharedText.asset.opening": "Opening",
  "sharedText.asset.movements": "Movements",
  "sharedText.set.credit": "Credit",
  "sharedText.voucher.backToVat": "Back to the VAT return",
  "sharedText.vat.vatCode": "VAT code",
  "sharedText.bank.markVoucherLostTitle": "Mark voucher as lost",
  "sharedText.bank.voucherLostReason": "Explanation",
  "pay.salaryLineDeleted": "Salary line deleted.",
  "pay.salaryLineNotFound": "The salary line no longer exists.",
  "pay.deleteSalaryLine": "Delete salary line",
  "pay.deleteSalaryLineConfirm": "Delete “{{name}}” from this payroll draft?",
  "pay.accountingVouchers": "Accounting vouchers",
  "pay.payrollVoucher": "Payroll voucher",
  "pay.paymentVoucher": "Payment voucher",
  "pay.paymentVoucherInDifferentYear": "The payment was posted in {{year}} and is therefore shown in that year’s trial balance.",
  "pay.settleSalaryLiability": "Settlement of salary payable",
  "pay.settleEmployeeExpense": "Settlement of employee expense",
  "pay.paymentFromBank": "Payment from bank account"
});
